import { HttpNoData } from "../Core";

export async function getManagers(jwt) {
    const response = await HttpNoData('/api/v0/managers', 'GET', jwt);

    if (!response.statusSuccessful)
        console.log(response.error);

    return response.data;
}